const r = () => Math.random().toString().split(".")[1], e = (a, t) => {
  if (!a)
    return t;
  const o = a.getAttribute("data-exo-locatorId-suffix");
  return o ? `${t}-${o}` : t;
};
export {
  r as a,
  e as g
};
